import React, { useCallback } from 'react'
import styled from '@emotion/styled'

import { Trash2 } from 'react-feather'
import Table, { TableRow, TableCell } from 'Components/Table'
import { colors } from 'Constants'

import { toast } from 'react-toastify'
import { createModal } from 'Components/Modal'
import { EditNewLinkModal } from './EditLinkModal'
import { DeleteNewLinkModal } from './DeleteLinkModal'

const TableRowClickableStyle = styled(TableRow)`
  cursor: pointer;
  > * {
    transition: 0.2s background-color;
  }
  :hover {
    > * {
      background-color: ${colors.background900};
    }
  }
`

const TableRowClickable = ({ data, ...props }) => (
  <TableRowClickableStyle
    onClick={() => {
      const { customLinks, setCustomLinks } = props
      // TODO: Handle modal for editing here
      createModal(
        <EditNewLinkModal
          customLink={data}
          setCustomLinks={setCustomLinks}
          customLinks={customLinks}
        />
      )
    }}
    data={data}
    {...props}
  />
)

const columns = [
  {
    header: 'Icon',
    accessor: 'icon'
  },
  {
    header: 'Name',
    accessor: 'shortName'
  },
  {
    header: 'Description',
    accessor: 'longName'
  },
  {
    header: 'Link',
    accessor: 'url'
  },
  {
    header: 'Active',
    accessor: 'deleted',
    size: '0.5x'
  }
]

export const CustomLinkTable = ({ customLinks, setCustomLinks, updateLinks }) => {
  const DeleteCell = useCallback(
    ({ data }) => (
      <TableCell
        xAlign
        onClick={e => {
          e.stopPropagation()
          const selectedLink = customLinks.find(link => link.id === data.id)
          if (!selectedLink) return toast.error('Failed to find custom link to delete')

          createModal(
            <DeleteNewLinkModal
              customLink={selectedLink}
              customLinks={customLinks}
              setCustomLinks={setCustomLinks}
              updateLinks={updateLinks}
            />
          )
        }}
      >
        <Trash2 />
      </TableCell>
    ),
    [customLinks]
  )

  const columnsWithDelete = [
    ...columns,
    { header: 'Delete', size: '0.2x', accessor: 'delete', Cell: DeleteCell }
  ]

  return (
    <Table
      columns={columnsWithDelete}
      data={customLinks}
      Row={TableRowClickable}
      setCustomLinks={setCustomLinks}
    />
  )
}
